import * as React from "react";
import classNames from "classnames";
import OutsideClickHandler from "@graffer-inc/react-outside-click-handler";
import { LinkButton } from "../../../atoms/link-button";

export const BulkApplicationSelectDropdown: React.FC<{
  onOpenCsvUploadModal: () => void;
  isActive: boolean;
  onClose: () => void;
  onOpen: () => void;
}> = ({ onOpenCsvUploadModal, isActive, onClose, onOpen }) => {
  return (
    <div
      className={classNames("dropdown c-hoverable", {
        "is-active": isActive,
      })}
      onClick={isActive ? onClose : onOpen}
    >
      <div className="dropdown-trigger">
        <span className="icon px-2">
          <i className="fas fa-angle-down" aria-hidden="true" />
        </span>
      </div>
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="dropdown-menu" role="menu">
          <div className="dropdown-content">
            <LinkButton
              className="dropdown-item has-text-weight-normal"
              style={{ display: "block", padding: "15px 10px" }}
              onClick={(e: any) => {
                e.stopPropagation();
                onOpenCsvUploadModal();
              }}
            >
              CSVで複数の申請を選択
            </LinkButton>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};
